import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {DoctorService} from '../../../services/doctor/doctor.service';
import {iResponseList} from '../../../models/response/response.model';
import {DoctorModel} from '../../../models/doctor/doctor.model';
import {Router} from '@angular/router';
import {DecimalPipe} from '@angular/common';
import {BrowserStorageService} from '../../../services/browser-storage/browser-storage.service';

@Component({
  selector: 'app-doctor-selection',
    imports: [
        DecimalPipe
    ],
    providers: [BrowserStorageService],
  templateUrl: './doctor-selection.component.html',
  styleUrl: './doctor-selection.component.sass'
})
export class DoctorSelectionComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>()

    doctorList: DoctorModel[] = [];

    constructor(
        private doctorService: DoctorService,
        private router: Router,
        private browserStorageService: BrowserStorageService
    ) {
    }

    ngOnInit(): void {
        this.getDoctors();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    selectDoctor(doctor: DoctorModel) {
        this.browserStorageService.set('selectedDoctor', doctor);
        this.router.navigate(['termine/buchung'], {state:{doctor: doctor}});
    }

    private getDoctors(): void {
        const query = {
            showDeleted: false
        }
        this.doctorService.getDoctors(query)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponseList<DoctorModel>) => {
                    this.doctorList = response.data;
                },
                error: (error) => {
                    console.error(error)
                }
            })
    }

}
